function handleFileUpload(event) {
    const fileInput = event.target;
    const fileName = fileInput.files[0] ? fileInput.files[0].name : '';

    if (fileName) {
        document.querySelector('.beforeUploadInvoice').style.display = 'none';
        document.querySelector('.afterUploadInvoice').style.display = 'block';
        document.getElementById('fileName').textContent = fileName;
        //document.querySelector('.error-message').style.display = 'none';
    } else {
        document.querySelector('.beforeUploadInvoice').style.display = 'block';
        document.querySelector('.afterUploadInvoice').style.display = 'none';
    }
}

// Drag-and-Drop Functionality
const dropZone = document.getElementById('dropZone');

dropZone.addEventListener('dragover', (event) => {
    event.preventDefault();
    event.stopPropagation();
    dropZone.style.borderColor = "#007bff";  // Highlight the border on dragover
});

dropZone.addEventListener('dragleave', () => {
    dropZone.style.borderColor = "#ccc";  // Reset border color on drag leave
});

dropZone.addEventListener('drop', (event) => {
    event.preventDefault();
    event.stopPropagation();

    const fileInput = document.getElementById('invoiceinputOne');
    fileInput.files = event.dataTransfer.files;  // Assign dropped files to the file input
    handleFileUpload({ target: fileInput });
});

// Optional: Show error if no file is uploaded (if needed)
function validateUpload() {
    const fileInput = document.getElementById('invoiceinputOne');
    if (!fileInput.files.length) {
       // //document.querySelector('.error-message').style.display = 'block';
    }
}



function handleMultipleFileUpload(event) {
    const fileInput = event.target;
    const fileNamesContainer = document.getElementById('fileNames');

    if (fileInput.files.length) {
        document.querySelector('.beforeUploadDefect').style.display = 'none';
        document.querySelector('.afterUploadDefect').style.display = 'block';
        //document.querySelector('.error-message').style.display = 'none';

        const fileNames = Array.from(fileInput.files).map(file => file.name).join(', ');
        fileNamesContainer.textContent = fileNames;
    } else {
        document.querySelector('.beforeUploadDefect').style.display = 'block';
        document.querySelector('.afterUploadDefect').style.display = 'none';
    }
}

// Drag-and-Drop Functionality
const defectDropZone = document.getElementById('defectDropZone');

defectDropZone.addEventListener('dragover', (event) => {
    event.preventDefault();
    event.stopPropagation();
    defectDropZone.style.borderColor = "#007bff";  // Highlight border on dragover
});

defectDropZone.addEventListener('dragleave', () => {
    defectDropZone.style.borderColor = "#ccc";  // Reset border color on drag leave
});

defectDropZone.addEventListener('drop', (event) => {
    event.preventDefault();
    event.stopPropagation();

    const fileInput = document.getElementById('defectInput');
    fileInput.files = event.dataTransfer.files;  // Assign dropped files to the file input
    handleMultipleFileUpload({ target: fileInput });
});

// Optional: Show error if no file is uploaded (if needed)
function validateUpload() {
    const fileInput = document.getElementById('defectInput');
    if (!fileInput.files.length) {
        //document.querySelector('.error-message').style.display = 'block';
    }
}



  //****** Pincode Data Fetch Function ******
  function fetchPincodeData(pincode, cityClass, stateClass, errorClass) {
    const csvFile = "https://cdn.shopify.com/s/files/1/0021/8362/6851/files/pincode_data.csv?v=1718966385";

    if (pincode.length < 6) {
      // Display an error if the pincode is less than 6 digits
      const errorMessage = document.querySelector(`${errorClass}`);
      if (errorMessage) errorMessage.textContent = "Pincode must be 6 digits";
      return;
    }

    axios.get(csvFile)
      .then(response => {
        processData(response.data, pincode, cityClass, stateClass, errorClass);
      })
      .catch(error => {
        console.error("Error fetching the CSV file:", error);
      });
  }

  function processData(csv, pincode, cityClass, stateClass, errorClass) {
    const lines = csv.split("\n");
    let pincodeFound = false;
    let city, stateName;

    for (let i = 1; i < lines.length; i++) {
      const currentLine = lines[i].split(",");
      const currentPincode = currentLine[0].trim();

      if (currentPincode === pincode) {
        city = currentLine[1].trim();
        stateName = currentLine[2].trim();
        pincodeFound = true;
        break;
      }
    }

    const cityInput = document.querySelector(`${cityClass}`);
    const stateInput = document.querySelector(`${stateClass}`);
    const errorMessage = document.querySelector(`${errorClass}`);

    if (pincodeFound) {
      if (cityInput) cityInput.value = city;
      if (stateInput) stateInput.value = stateName;
      document.querySelector('#cityState').value = city + " , " + stateName;
       
      if (errorMessage) errorMessage.textContent = ""; // Clear any error message
    } else {
      if (cityInput) cityInput.value = "";
      if (stateInput) stateInput.value = "";
      document.querySelector('#cityState').value = "";
      if (errorMessage) errorMessage.textContent = "Pincode not found"; // Show error if pincode not found
    }
  }

  // Adding the function to the window object so it can be called globally
  window.fetchPincodeData = fetchPincodeData;

  
  
  


  
